import projectNotesComponent from './project-notes.component';

const projectNotesModule = angular.module('projectNotes', [
])
  .component('projectNotes', projectNotesComponent)
  .name;

export default projectNotesModule;
